import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { FIRST_PAGE, MAX_PER_PAGE } from 'constants/constants';
import { GeneratedContentPage, QueryGeneratedContentsArgs } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import { buildQueryKey } from 'utils/buildQueryKey';
import clientUtil from 'utils/clientUtil';

type TVariables = QueryGeneratedContentsArgs;
type TData = GeneratedContentPage;

const MOCK: TVariables = {
  contentTypeFilter: undefined,
  languageFilter: undefined,
  page: FIRST_PAGE,
  perPage: MAX_PER_PAGE,
  query: undefined,
  skipPagination: undefined,
  sortAttribute: undefined,
  sortOrder: undefined
};

export const useContentGenerationDataList = (
  variables: TVariables = MOCK,
  options: Omit<UseQueryOptions<unknown, TGenericError, TData>, 'queryKey'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    query generatedContents(
      $query: String
      $sortAttribute: GeneratedContentSortAttributeEnum
      $sortOrder: SortOrderEnum
      $languageFilter: [OrderableTargetLanguageCodesEnum!]
      $contentTypeFilter: GeneratedContentTypeEnum
      $contentFormatFilter: GeneratedContentFormatEnum
      $page: Int
      $perPage: Int
    ) {
      generatedContents(
        query: $query
        sortAttribute: $sortAttribute
        sortOrder: $sortOrder
        languageFilter: $languageFilter
        contentTypeFilter: $contentTypeFilter
        contentFormatFilter: $contentFormatFilter
        page: $page
        perPage: $perPage
      ) {
        pagesCount
        nodes {
          id
          contentFormat
          contentType
          createdAt
          languages
          status
          title
          words
        }
      }
    }
  `;

  return useQuery<unknown, TGenericError, TData>({
    ...options,
    queryKey: ['useContentGenerationDataList', ...buildQueryKey({ ...MOCK, ...variables })],
    queryFn: async () => {
      return client.request({
        data: {
          gql: graphql,
          variables
        }
      });
    }
  });
};
